import classes from '@/components/Shares/Input.module.css';
import { InputValidateError } from '@/components/Shares/InputValidateError';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Image, Paper, Stack, Tabs, Text, TextInput, Title } from '@mantine/core';
import { useForm } from '@mantine/form';
import { ClaimButton } from '../ClaimButton';
export const Coupons: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  const form = useForm({
    initialValues: {
      code: ''
    },
    validate: {
      code: value => value.length < 6 ? <InputValidateError notification={i18n._('Invalid code')} /> : null
    }
  });
  return <Tabs.Panel value="coupons">
      <Paper radius={5} bg="var(--bg-600)" p={38} w={{
      base: '100%',
      sm: 722,
      lg: 650
    }} mx="auto">
        <Stack justify="center" align="center" gap={0}>
          <Title fz={20} className={gunterzBold.className} c="var(--text-white)" ta="center">
            {i18n._('Redeem')}
            <Text span inherit c="var(--text-prime)">
              {i18n._(' Coupon Code')}
            </Text>
          </Title>

          <Box>
            <Image src="/assets/wallet/coupons.svg" alt="coupons" w={{
            base: 210,
            sm: 244
          }} h={{
            base: 188,
            sm: 244
          }} />
          </Box>

          <form onSubmit={form.onSubmit(() => setOpenModal(MODAL.COUPONS))}>
            <Stack justify="center">
              <TextInput w={{
              base: 348,
              sm: 474,
              lg: 466
            }} classNames={{
              input: classes.input_style_1,
              error: classes.error
            }} placeholder={i18n._('add your code here')} key={form.key('code')} {...form.getInputProps('code')} />

              <ClaimButton />
            </Stack>
          </form>
        </Stack>
      </Paper>
    </Tabs.Panel>;
};